// extracted by mini-css-extract-plugin
export default {"footerContainer":"FooterContainer_footerContainer__wbQGp"};